import { Component, OnInit } from '@angular/core';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { UtilForms } from 'src/app/utils/util-forms';
import { FormGroup, FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';
import { Usuario } from 'src/app/models/usuario-login';
import { ModalMotivoBloqueioComponent } from 'src/app/app-components/modal-motivo-bloqueio/modal-motivo-bloqueio.component';
import { UserConfigsUtils } from 'src/app/utils/UserConfigsUtils';

@Component({
  selector: 'app-list-unidade',
  templateUrl: './list-unidade.component.html',
  styleUrls: ['./list-unidade.component.scss']
})


export class ListUnidadeComponent implements OnInit {

  listaEstados = UtilForms.optionsEstado.nome;
  listaMotivos = [
    {label:'FINANCEIRO'},
    {label: 'CONTRATUAL'}];
  usuario: Usuario;
  sorting = { idunidade: '', nomefantasia: 'asc', unidadepai: '', nome: '', documento: '', estado: '', motivobloqueio: ''};

  filter = {
    page: 1,
    per_page: 10,
    sorting: { nomefantasia: 'asc'},
    filter: {idunidade: '', nomefantasia: '', unidadepai: '', nome: '', documento: '', estado: '', motivobloqueio: ''}
  };
  total = 0;
  tableLoading = true;
  listaUnidades: any = [];
  cliente:boolean = false;

  pesquisa = new FormGroup({
    'idunidade': new FormControl(''),
    'unidadepai': new FormControl(''),
    'nomefantasia': new FormControl(''),
    'nome': new FormControl(''),
    'documento': new FormControl(''),
    'estado': new FormControl(''),
    'motivobloqueio': new FormControl('')
  });

  first: number = 0;
  unidade: any = {};
  dynamicdownloadName: string = "Unidades"

  cols: any = [
    { field: 'idunidade', header: '#' },
    { field: 'unidadepai', header: 'Unidade pai' },
    { field: 'nomefantasia', header: 'Nome Unidade' },
    { field: 'nome', header: 'Tipo Unidade' },
    { field: 'documento', header: 'Documento' },
    { field: 'estado', header: 'Estado' },
    { field: 'motivobloqueio', header: 'Motivo do bloqueio'}
  ];

  fields: any = ['idunidade', 'unidadepai', 'nomefantasia', 'nome', 'documento', 'estado', 'motivobloqueio'];

  constructor(private loginService: LoginService, private activatedRoute: ActivatedRoute, private modalMsgService: ModalMsgService, private router: Router, private modalService: NgbModal, private unidadeService: UnidadeService) {
    this.loginService.getLogIn().pipe(first()).subscribe(u => this.usuario = u);
    this.cliente = this.activatedRoute.snapshot.data.cliente || false;
    this.getListaUnidades();
    this.pesquisa.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(r => {
      this.filter.filter = r;
      this.getListaUnidades();
    });
  }

  ngOnInit() {
  }

  removeEmpty(obj) {
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  getListaUnidades() {
    this.tableLoading = true;
    this.filter.sorting = this.removeEmpty({...this.sorting});
    if(this.filter.filter.documento.length >13){
      this.filter.filter.documento = this.filter.filter.documento.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
    }
    this.unidadeService.getListaUnidadeNomeFilter(this.filter, ['loading']).then(r => {
      this.total = r.total;
      this.listaUnidades = r.lista;
      this.tableLoading = false;
    });
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.getListaUnidades();
  }

  nextPage() {
    this.getListaUnidades();
  }

  mudarStatusUnidade(status, unidade) {
    unidade.status = status;
    
    const params = {
      ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
      ...unidade
    }

    if(!status){
      const modalRef = this.modalService.open(ModalMotivoBloqueioComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Alterar Status da unidade';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.unidadeService.atualizarStatusUnidade(params, justificativa)
          .then(r => this.getListaUnidades())
          .catch(e => this.modalMsgService.openDialog('Erro ao atualizar unidade', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao atualizar unidade',
          'Informe uma Justificativa para concluir a operação', 'danger');
          unidade.status = !status;
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao atualizar unidade',
      'Informe uma Justificativa para concluir a operação', 'danger').finally(()=> unidade.status = !status));
    } else {
      this.unidadeService.atualizarStatusUnidade(params, '')
          .then(r => this.getListaUnidades())
          .catch(e => this.modalMsgService.openDialog('Erro ao atualizar unidade', '', 'danger'));
    }
  }

  removerUnidade(unidade) {

    const params = {
      ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
      ...unidade
    }

    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover unidade';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.unidadeService.removerUnidade(params, justificativa)
          .then(r => this.getListaUnidades())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover unidade', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover unidade',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover unidade',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

  editarUnidade(unidade) {
      this.router.navigate(['unidade', 'editar', unidade.uuidunidade]);
  }

  visualizarUnidade(unidade) {
    this.router.navigate(['unidade', 'visualizar', unidade.uuidunidade]);
}

}
